export const BrandStoryController = {
    index(): void {},
};
